import { Map } from 'immutable';
import type { AnyAction } from 'redux';

import { ADD_MULTIPLE, UPDATE, ADD } from './types';
import type AutoSourcingRule from './model';

export type AutoSourcingRuleMap = Map<string, AutoSourcingRule>;

const initialState = Map<string, AutoSourcingRule>();

export default (state = initialState, action: AnyAction): AutoSourcingRuleMap => {
  switch (action.type) {
    case ADD_MULTIPLE:
      return state.merge(action.autoSourcingRules);

    case UPDATE:
      return state.set(action.autoSourcingRule.id, action.autoSourcingRule);

    case ADD:
      return state.set(action.autoSourcingRule.id, action.autoSourcingRule);

    default:
      return state;
  }
};
